export default __webpack_public_path__ + "static/media/TITULOS_07.ce71b98e.png";